export default __webpack_public_path__ + "static/media/insert-row.5e78e3d9.svg";